import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const SEV_COLOR = {
  critical: [190, 30, 45],
  high: [214, 94, 32],
  medium: [202, 160, 40],
  low: [70, 120, 180],
  info: [120, 120, 130],
};

export function downloadVulnPdf(filename, { stats, scans = [], vulns = [] }) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const now = new Date();

  // Header band
  doc.setFillColor(12, 12, 14);
  doc.rect(0, 0, 595, 90, "F");
  doc.setTextColor(220, 40, 55);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.text("CRIMSON.OPS", 40, 44);
  doc.setFontSize(10);
  doc.setTextColor(200, 200, 205);
  doc.setFont("helvetica", "normal");
  doc.text("Rapport de securite defensif", 40, 62);
  doc.text(now.toLocaleString(), 40, 76);

  let y = 120;
  doc.setTextColor(20, 20, 24);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.text("Synthese", 40, y);
  y += 18;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  const summary = [
    `Scans realises : ${stats?.scans ?? scans.length}`,
    `Hotes analyses : ${stats?.hosts ?? 0}`,
    `Vulnerabilites totales : ${stats?.vulns ?? vulns.length}`,
    `Critiques : ${stats?.critical ?? vulns.filter(v => v.severity === "critical").length}`,
  ];
  summary.forEach((s) => { doc.text(s, 48, y); y += 15; });

  y += 10;
  autoTable(doc, {
    startY: y,
    head: [["ID", "Titre", "Hote:Port", "Service", "Severite", "CVSS", "Source"]],
    body: vulns.map((v) => [
      v.id || "",
      (v.title || "").slice(0, 60),
      `${v.host || ""}:${v.port || ""}`,
      (v.service || "").toUpperCase(),
      (v.severity || "info").toUpperCase(),
      Number(v.cvss || 0).toFixed(1),
      v.source || "",
    ]),
    styles: { fontSize: 8, cellPadding: 4, overflow: "linebreak" },
    headStyles: { fillColor: [20, 20, 24], textColor: [230, 230, 235] },
    columnStyles: { 1: { cellWidth: 150 } },
    didParseCell: (data) => {
      if (data.section === "body" && data.column.index === 4) {
        const sev = (vulns[data.row.index]?.severity || "info").toLowerCase();
        const c = SEV_COLOR[sev] || SEV_COLOR.info;
        data.cell.styles.textColor = c;
        data.cell.styles.fontStyle = "bold";
      }
    },
    margin: { left: 40, right: 40 },
  });

  if (vulns.length === 0) {
    doc.setFontSize(10);
    doc.setTextColor(120, 120, 130);
    doc.text("Aucune vulnerabilite detectee.", 48, y + 10);
  }

  const pages = doc.getNumberOfPages();
  for (let i = 1; i <= pages; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(150, 150, 155);
    doc.text(`CRIMSON.OPS - scans defensifs autorises uniquement - page ${i}/${pages}`, 40, 820);
  }

  doc.save(filename);
}
